export function isVisible(element, vp) {
  /* This checks if the element is in the viewport area, you could also
   * check the display and visibility of its style.
   */
  var rect = element.getBoundingClientRect()
  var x = rect.left
  var x2 = x + element.offsetWidth
  var y = rect.top - 100
  var y2 = y + element.offsetHeight
  return !(x >= vp.w || y >= vp.h || x2 < 0 || y2 < 0)
}

export function matches(element, vp) {
  // console.log(element, element.attributes)
  // console.log("verseref", element.attributes, element.getAttribute("verseref"))
  /* You can filter the elements even further */
  return (
    element.getAttribute("verseref") !== null &&
    element.getAttribute("verseref") !== undefined &&
    isVisible(element, vp)
  )
}

export function viewport() {
  this.x = window.pageXOffset
  this.w = window.innerWidth
  this.x2 = this.x + this.w - 1
  this.y = window.pageYOffset
  this.h = window.innerHeight
  this.y2 = this.y + this.h - 1
  return this
}

export function addMatch(element, array) {
  /* An element may be in more than one block, so you need
   * to check if it wasn't already added.
   */
  for (var i = 0; i < array.length; ++i) {
    if (array[i] === element) return
  }
  array.push(element)
}

// export function removeElement(element) {
//   /* This works fine if the rest of the nodes stayed in the
//    * same position with the same size when element was added.
//    */
//   if (!element.getBoundingClientRect) return;
//   var rect = element.getBoundingClientRect();
//   var y = rect.top + window.pageYOffset;
//   var y2 = y + element.offsetHeight;
//   var from = Math.trunc(y / blockHeight);
//   var to = Math.trunc(y2 / blockHeight);
//   for (var b = from; b <= to; ++b) {
//     var i = blocks[b].indexOf(element);
//     if (i > -1) {
//       blocks[b].splice(i, 1);
//     }
//   }
// }
